import { render, staticRenderFns } from "./institutionalSetup.vue?vue&type=template&id=144f4eca&scoped=true"
import script from "./institutionalSetup.vue?vue&type=script&lang=js"
export * from "./institutionalSetup.vue?vue&type=script&lang=js"
import style0 from "./institutionalSetup.vue?vue&type=style&index=0&id=144f4eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f4eca",
  null
  
)

export default component.exports